import styled from 'styled-components';
import { StyledPopUpBlock } from '../styled';

export const StyledPopupHeader = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.hover};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 0px 30px;
  z-index: 1;
  width: 100%;
  height: 85px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 50px;
    width: auto;
    height: auto;
    max-height: 50px;
  }
`;
export const StyledPopupContent = styled.div`
  position: relative;
  padding-bottom: 20px;
`;

export const StyledPopUpBlockNoPadding = styled(StyledPopUpBlock)`
  width: 420px;
  padding: 0;
  border-radius: ${({ theme }) => theme.cardRadius};
  overflow: hidden;
`;

export const StyledParagraph = styled.p`
  font-family: 'Archivo';
  font-size: 15px;
  line-height: 26px;
  padding: 30px;
  color: ${({ theme }) => theme.text};
`;

export const StyledReportTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledReportNameContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const StyledReportName = styled.div`
  font-family: Archivo;
  font-size: 14px;
  font-weight: bold;
  margin-right: 18px;
  line-height: 18px;
  color: ${({ theme }) => theme.text};
`;

export const StyledNotAvailable = styled.span`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: row;
  padding: 20px 0px;
  font-size: 14px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  color: ${({ theme }) => theme.textFaint};
  &:last-child {
    border-bottom: 0;
  }
`;

export const StyledCommentary = styled.p`
  width: 100%;
`;
